import React, { useEffect, useState } from "react";
import { IconButton, Badge, Tooltip } from "@mui/material";
import Iconify from "../../../../components/iconify";
import { useNavigate } from "react-router-dom";
import { useGetChatsQuery } from "../../../../features/chats/chatsApiSlice";
import {
  useSocket,
  useSocketConnectionStatus,
} from "../../../../app/socket/SocketProvider";

export default function UsersPopover() {
  const navigate = useNavigate();
  const { data: chats, refetch } = useGetChatsQuery();
  const [unreadCounter, setUnreadCounter] = useState(0);

  const socket = useSocket();
  const isConnected = useSocketConnectionStatus();

  useEffect(() => {
    if (socket) {
      socket.on("refreshChats", () => {
        refetch();
      });

      return () => {
        socket.off("refreshChats");
      };
    }
  }, [socket, refetch]);

  useEffect(() => {
    if (chats) {
      let counter = 0;
      chats.forEach((chat) => {
        if (chat.unreadCount > 0) {
          counter++;
        }
      });
      setUnreadCounter(counter);
    }
  }, [chats]);

  return (
    <IconButton
      onClick={() => navigate("/dashboard/chat")}
      sx={{ width: 40, height: 40, position: "relative" }}
    >
      <Badge badgeContent={unreadCounter} color="error">
        <Iconify icon="majesticons:chat-2" />
      </Badge>

      <Tooltip title={isConnected ? "Online" : "Offline"}>
        <Badge
          overlap="circular"
          color={isConnected ? "success" : "error"}
          variant="dot"
          sx={{
            position: "absolute",
            bottom: 0,
            right: 10,
            height: 10,
          }}
        />
      </Tooltip>
    </IconButton>
  );
}
